module.exports = __webpack_public_path__ + "static/media/izmeritelnue_preobrazovateli_vt.3ca15093.pdf";